import React from 'react';
import logo from "../../../assets/img/logo.png";
import { Button } from 'reactstrap';
import { deleteCookie } from '../../../services/utils';

function Brand() {

  const logoStyle = {
    height: "80px",
    background: "white",
    borderRadius: "5px",
    padding: "10px"
  }

  const stickyLogoStyle = {
    height: "50px",
    padding: "5px"
  }

  const showChat = (e) => {
    window.$chatwoot.toggle();
    e.stopPropagation();
    /*
		window.HappyFoxChat.showWidget(() => {
			console.log('show chat callback');
		});
		window.HappyFoxChat.expandChatbox(() => {
			console.log('show chat callback');
    });
    */
  }
  
  const logout = () => {
		console.log('logout');
		deleteCookie('cla_token', 'christmaslistapp.com');
		deleteCookie('cla_uid', 'christmaslistapp.com');
		window.location = "https://www.christmaslistapp.com/sign-in";
	}

  return (<>
    <div className="kt-header__brand   kt-grid__item" id="kt_header_brand">
        <div className="kt-header__brand-logo">
            <a href="https://www.christmaslistapp.com">
                <img alt="Logo" style={logoStyle} src={logo} className="kt-header__brand-logo-default" />
                <img alt="Logo" style={stickyLogoStyle} src={logo} className="kt-header__brand-logo-sticky" />
            </a>
        </div>
    </div>
    <div className="kt-header__topbar kt-hidden-tablet-and-mobile">
      <Button onClick={(e)=> showChat(e)} color="metal" className="btn-metal">
        <i className="flaticon-chat"></i> Support
      </Button>
      <Button onClick={()=> logout()} color="none" className="ml-2 btn-link text-white">
        <i className="flaticon-logout"></i> Logout
      </Button>
    </div>
    </>
  );
}

export default Brand;